import React from 'react';
import { Mic, Square, Loader2, CheckCircle } from 'lucide-react';

// recording state: 'idle' | 'recording' | 'recorded' | 'uploading'
export default function RecordButton({ state, onClick, disabled }) {
  const base = 'w-24 h-24 rounded-full flex items-center justify-center transition-colors shadow-lg';
  if (state === 'recording') {
    return (
      <button type="button" onClick={onClick} className={`${base} bg-red-500 hover:bg-red-400 animate-pulse`}>
        <Square size={32} className="text-white" fill="white" />
      </button>
    );
  }
  if (state === 'uploading') {
    return (
      <div className={`${base} bg-slate-400 cursor-not-allowed`}>
        <Loader2 size={32} className="text-white animate-spin" />
      </div>
    );
  }
  if (state === 'recorded') {
    return (
      <button type="button" onClick={onClick} disabled={disabled} className={`${base} bg-blue-500 hover:bg-blue-400`}>
        <CheckCircle size={32} className="text-white" />
      </button>
    );
  }
  return (
    <button type="button" onClick={onClick} disabled={disabled} className={`${base} bg-slate-600 hover:bg-slate-500 disabled:opacity-40 disabled:cursor-not-allowed`}>
      <Mic size={32} className="text-white" />
    </button>
  );
}
